module.exports = __webpack_public_path__ + "img/arrows.3c7988c3.png";